import React, { useEffect, useState } from "react";
import "../../styles/Partner.scss";

interface SupportItem {
  id: number;
  name: string;
  logo: string;
}

interface SupportJson {
  support: SupportItem[];
  sponsor: any[];
  "retail-partner": SupportItem[];
}

const Partner: React.FC = () => {
  const [retailPartners, setRetailPartners] = useState<SupportItem[]>([]);

  useEffect(() => {
    fetch("/resources/support.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load JSON");
        return res.json();
      })
      .then((data: SupportJson) => {
        setRetailPartners(data["retail-partner"] || []);
      })
      .catch((err) => {
        console.error("Error loading support.json:", err);
      });
  }, []);

  return (
    <section className="partner-section">
      <h2>Retail Partner</h2>

      <div className="partner-big-box">
        {retailPartners.map((item) => (
          <div className="partner-logo-wrapper" key={item.id}>
            <img src={item.logo} alt={item.name} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Partner;
